// eslint-disable-next-line import/prefer-default-export
export const rutCleaner = rut => {
  let cleanRut = rut.replace(/\./g, '');
  cleanRut = cleanRut.replace(/-/g, '');
  cleanRut = `${cleanRut.slice(0, -1)}-${cleanRut.slice(-1)}`;
  return cleanRut;
};
